/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { camelCase, cloneDeep, uniqueId } from 'lodash';

function handleInitialAdjustments({
  questionnaire,
  permissions
}) {
  const nationality = (questionnaire.find(
    qst => qst.idQuestion === 1656
  )?.answer || '').toLowerCase().includes('brasil');

  const partnerNotSelected = questionnaire.find(
    qst => qst.idQuestion === 2040
  )?.idAnswerOption === 7694;

  return questionnaire.map(question => {
    if (question.idQuestion === 1654) {

      const isEnabled = question.answer && question.answer.length === 11;

      questionnaire = questionnaire.map(qst => {
        if ([1655, 1656].includes(qst.idQuestion)) {
          qst.disabled = !isEnabled;
          qst.behaviorObject.isReadOnly = !isEnabled;
        }

        if ([1782, 1785, 1792, 1786, 1658].includes(qst.idQuestion)) {
          qst.disabled = nationality;
          qst.behaviorObject.isReadOnly = nationality;
        }

        return qst;
      });
    }

    if (question.idQuestion === 1660) {
      questionnaire = questionnaire.map(qst => {
        if ([1713, 1714, 1737, 1799, 1800].includes(qst.idQuestion)) {
          qst.visibleQuestion = question?.idAnswerOption === 7253 || question?.idAnswerOption === 7257;
          if (!qst.visibleQuestion) {
            qst.answer = null;
            qst.idAnswerOption = null;
          }
        }

        return qst;
      })
    }

    if (question.idQuestion === 1737) {
      questionnaire = questionnaire.map(qst => {
        if ([1799].includes(qst.idQuestion)) {
          qst.visibleQuestion = question?.idAnswerOption === 7375;
          if (!qst.visibleQuestion) {
            qst.answer = null;
            qst.idAnswerOption = null;
          }
        }

        return qst;
      })
    }

    if (question.idQuestion === 1781) {
      if (!nationality) {
        question.fieldMask = null;
        question.disabled = false;
        question.behaviorObject.isRequired = false;
        question.disabledSearch = true;
      } else {
        question.fieldMask = { type: "cep", mask: "00000-000" };
        question.behaviorObject.isRequired = true;
        question.disabledSearch = false;
      }
    }
    if (partnerNotSelected) question.visibleQuestion = false;


    if (permissions && !permissions?.FORMALIZE_CREDIT_ANALYSIS && !permissions?.ANALYZE_CREDIT_ANALYSIS_SAVE) {
      if ([1654, 1655].includes(question.idQuestion)) {
        question.disabled = true;
        question.behaviorObject.isReadOnly = true;
      }
    }

    return question;
  })
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue
}) {
  let saveFilteredQuestionnaire = false;

  if (question.idQuestion === 1654) {
    saveFilteredQuestionnaire = true;

    const isEnabled = value.length === 11;
    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if ([1655, 1656].includes(qst.idQuestion)) {
        qst.disabled = !isEnabled;
        qst.behaviorObject.isReadOnly = !isEnabled;
      }
      return qst;
    });
    question.answer = value;
    setFieldValue(question.key, value);
  }

  if ([1655, 1656, 1789, 1790, 1874, 1780, 1781, 1782, 1783, 1784, 1785, 1792, 1786, 1787, 1658, 1660, 1661].includes(question.idQuestion)) {
    saveFilteredQuestionnaire = true;
    question.answer = value;
    setFieldValue(question.key, value);
  }

  if (question.idQuestion === 1656) {
    const nationality = value && value.toLowerCase().includes('brasil');
    saveFilteredQuestionnaire = true;

    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if (qst.idQuestion === 1781) {
        if (!nationality) {
          qst.fieldMask = null;
          qst.disabled = false;
          qst.behaviorObject.isRequired = false;
          qst.disabledSearch = true;
        } else {
          qst.fieldMask = { type: "cep", mask: "00000-000" };
          qst.behaviorObject.isRequired = true;
          qst.disabledSearch = false;
        }
      }

      if ([1782, 1785, 1792, 1786, 1658].includes(qst.idQuestion)) {
        qst.disabled = nationality;
        qst.behaviorObject.isReadOnly = nationality;
      }
      return qst;
    });
  }

  if (question.idQuestion === 1660) {
    saveFilteredQuestionnaire = true;
    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if ([1713, 1714, 1737, 1799, 1800].includes(qst.idQuestion)) {
        qst.visibleQuestion = value?.idAnswerOption === 7253 || value?.idAnswerOption === 7257;
        if (!qst.visibleQuestion) {
          qst.answer = null;
          qst.idAnswerOption = null;
          setFieldValue(qst.key, "")
        }
      }

      return qst
    })
  }

  if (question.idQuestion === 1661) {
    saveFilteredQuestionnaire = true;
    question.answer = value;
    setFieldValue(question.key, value);
  }

  if (question.idQuestion === 1737) {
    saveFilteredQuestionnaire = true;
    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if ([1799].includes(qst.idQuestion)) {
        qst.visibleQuestion = value?.idAnswerOption === 7375;
        if (!qst.visibleQuestion) {
          qst.answer = null;
          qst.idAnswerOption = null;
          setFieldValue(qst.key, "")
        }
      }

      return qst;
    })
  }

  if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1655) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        question.answer = data.nomeEmpresarial;
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1656) {
        setFieldValue && setFieldValue(question.key, data.endereco.pais.descricao);
        question.answer = data.endereco.pais.descricao;
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1658) {
        let capitalSocial = data.capitalSocial;
        if (capitalSocial <= 0) capitalSocial = 0;
        capitalSocial = capitalSocial / 100;

        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }

        setFieldValue && setFieldValue(question.key, capitalSocial);
        question.answer = capitalSocial;
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1780) {
        setFieldValue && setFieldValue(question.key, data.correioEletronico);
        question.answer = data.correioEletronico;
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1781) {
        question.answer = data.endereco.cep;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.fieldMask = null;
          question.disabled = false;
          question.behaviorObject.isRequired = false;
          question.disabledSearch = true;
        } else {
          question.fieldMask = { type: "cep", mask: "00000-000" };
          question.behaviorObject.isRequired = true;
          question.disabledSearch = false;
        }
        setFieldValue && setFieldValue(question.key, data.endereco.cep);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1782) {
        question.answer = `${data.endereco.tipoLogradouro} ${data.endereco.logradouro}`;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }
        setFieldValue && setFieldValue(question.key, `${data.endereco.tipoLogradouro} ${data.endereco.logradouro}`);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1783) {
        question.answer = data.endereco.numero;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }
        setFieldValue && setFieldValue(question.key, data.endereco.numero);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1784) {
        question.answer = data.endereco.complemento;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }
        setFieldValue && setFieldValue(question.key, data.endereco.complemento);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1785) {
        question.answer = data.endereco.bairro;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }
        setFieldValue && setFieldValue(question.key, data.endereco.bairro);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1786) {
        question.answer = data.endereco.uf;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }
        setFieldValue && setFieldValue(question.key, data.endereco.uf);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1788) {
        question.answer = '';
        setFieldValue && setFieldValue(question.key, '');
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1792) {
        question.answer = data.endereco.municipio.descricao;
        if (!data.endereco.pais.descricao.toLowerCase().includes('brasil')) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false;
        }
        setFieldValue && setFieldValue(question.key, data.endereco.municipio.descricao);
      }

      if (rootQuestion.idQuestion === 1654 && question.idQuestion === 1660) {
        const partnerCpfCnpj = data.ni
        const answerOption = question.answerOptions.find(v => v.idAnswerOption === (partnerCpfCnpj.length > 11 ? 7258 : 7253));

        if (answerOption.idAnswerOption !== 7253) {
          [1713, 1714, 1737, 1799, 1800].forEach(questionId => {
            const question = questionnaire.find(q => q.idQuestion === questionId);
            if (question) question.visibleQuestion = false;
          });
        }

        const result = {
          idAnswerOption: answerOption?.idAnswerOption,
          dsAnswerOption: answerOption?.dsAnswerOption,
          resultValue: answerOption?.behaviorObject?.resultValue || null
        };

        question.answer = answerOption?.dsAnswerOption;
        question.answerJson = answerOption.answerJson;
        question.idAnswerOption = answerOption?.idAnswerOption;
        setFieldValue && setFieldValue(question.key, result);
      }

      if (question.idQuestion === 1707) {
        const cnaePrimario = data.cnaePrincipal.codigo.substring(0, 2);
        if ([41, 42, 43].includes(Number(cnaePrimario))) {
          question.idAnswerOption = 7311;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7311).dsAnswerOption;
        } else {
          question.idAnswerOption = 7310;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7310).dsAnswerOption;
        }
      }

      if (question.idQuestion === 1711) {
        if (!data.situacaoEspecial) {
          question.idAnswerOption = 7319;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7319).dsAnswerOption;
        } else {
          question.idAnswerOption = 7320;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7320).dsAnswerOption;
        }
      }

      return question;
    })

    if (rootQuestion.idQuestion === 1654) {
      rootQuestion.answer = data.ni || "";
      setFieldValue(rootQuestion.key, rootQuestion.answer)
      setQuestionnaire(questionnaire);
      return;
    }

  } catch (e) {
    console.log('PARTNER - handleRequestSerproCnpj error', e)
  }
};

async function handleSearchZipCode({ rootQuestion, zipCodeData, questionnaire, setQuestionnaire, setFieldValue }) {
  try {
    questionnaire = questionnaire.map(question => {
      if (question.idQuestion === 1782) {
        if (zipCodeData.LONG_STREET_NAME === 'NA') {
          question.disabled = false;
          question.behaviorObject.isReadOnly = false;
        } else {
          question.behaviorObject.isReadOnly = true;
          question.disabled = true;
        }

        setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
        return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
      }

      if (question.idQuestion === 1781) {
        zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
        return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
      }

      if (question.idQuestion === 1785) {
        if (zipCodeData.DISTRICT === 'NA') {
          question.disabled = false;
          question.behaviorObject.isReadOnly = false;
        } else {
          question.behaviorObject.isReadOnly = true;
          question.disabled = true;
        }

        zipCodeData.ZIP_CODE = `${zipCodeData.DISTRICT}`.padStart(8, '0');
        setFieldValue && setFieldValue(question.key, String(zipCodeData.DISTRICT));
        return ({ ...question, answer: String(zipCodeData.DISTRICT) });
      }

      if (question.idQuestion === 1792) {
        setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
        return ({ ...question, answer: zipCodeData.CITY });
      }

      if (question.idQuestion === 1786) {
        setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
        return ({ ...question, answer: zipCodeData.STATE });
      }

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (error) {
    console.log('PARTNER - handleSearchZipCode error', error)
  }
};

function handlePartners({ partnersData, partners, setPartners }) {

  function checkPartnerNationality(ptr, qst) {
    if (qst.idQuestion === 1781) {
      if (!ptr.pais.descricao.toLowerCase().includes('brasil')) {
        qst.fieldMask = null;
        qst.disabled = false;
        qst.behaviorObject.isRequired = false;
        qst.disabledSearch = true;
      } else {
        qst.fieldMask = { type: "cep", mask: "00000-000" };
        qst.behaviorObject.isRequired = true;
        qst.disabledSearch = false;
      }
    } else {
      if (!ptr.pais.descricao.toLowerCase().includes('brasil')) {
        qst.behaviorObject.isReadOnly = false;
        qst.disabled = false;
      }
    }
  }

  try {

    if (!partnersData || !partnersData.length) return;

    const partnersGroup = []
    let questionPartner = []

    partnersData.map((ptr) => {
      questionPartner = [];

      partners[0].map((qst) => {
        qst = cloneDeep(qst);
        qst.key = `${camelCase(qst.dsQuestion)}_${qst.idQuestion}${uniqueId()}_${uniqueId()}`;
        qst.idQuestionnaireAnswers = null;
        qst.idQuestionnaireAnswersParent = null;
        qst.idQuestionnaireAnswersRoot = null;
        qst.answer = null;
        qst.idAnswerOption = null;

        if (qst.idQuestion === 1654) {
          qst.answer = ptr.cpf || ptr.cnpj;
        }

        if (qst.idQuestion === 1655) {
          qst.answer = ptr.nome;
        }

        if (qst.idQuestion === 1656 && ptr?.pais) {
          qst.answer = ptr.pais.descricao;
        }

        if (qst.idQuestion === 1658) {
          if (!ptr.pais.descricao.toLowerCase().includes('brasil')) {
            qst.behaviorObject.isReadOnly = false;
            qst.disabled = false;
          }
        }

        if (qst.idQuestion === 1660) {
          if (ptr.cnpj) {
            const answerOption = qst.answerOptions.find(v => v.idAnswerOption === 7258);
            qst.idAnswerOption = 7258;
            qst.answer = answerOption?.dsAnswerOption;
            qst.idAnswerOption = answerOption?.idAnswerOption;
          }

          if (ptr.cpf) {
            const answerOption = qst.answerOptions.find(v => v.idAnswerOption === 7253);
            qst.idAnswerOption = 7253;
            qst.answer = answerOption?.dsAnswerOption;
            qst.idAnswerOption = answerOption?.idAnswerOption;
          }
        }

        if (qst.idQuestion === 1781) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.cep || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1782) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.logradouro || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1783) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.numero || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1784) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.complemento || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1785) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.bairro || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1786) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.uf || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1792) {
          if (ptr.cnpj) {
            qst.answer = ptr.dadosAdicionaisEmpresa?.ret_value?.endereco?.municipio.descricao || '';
            qst.disabled = true;
          }
          checkPartnerNationality(ptr, qst);
        }

        if (qst.idQuestion === 1787) {
          qst.answer = ptr.qualificacao;
        }

        if ([1713, 1714, 1737, 1799, 1800].includes(qst.idQuestion)) {
          qst.visibleQuestion = !ptr.cnpj;
        }

        questionPartner.push({ ...qst })
      })
      partnersGroup.push(questionPartner)
    })

    setPartners(partnersGroup)
  } catch (e) {
    console.log('handlePartner error', e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
  handleSearchZipCode,
  handlePartners,
}

export { events };
